<template>

  <div id="bar" v-show="show_bar">

      <router-link to="/" id="logo"></router-link>

      <div class="lnk_switch">
        <a :class="(theme == 'light' ? 'active' : '')" @click="$emit('change_theme', 'light')">בהיר</a>
        <a :class="(theme == 'dark' ? 'active' : '')" @click="$emit('change_theme', 'dark')">כהה</a>
      </div>
      <div id="bar_menu">
        <ul>
          <li v-for="item in menu" :key="item.link" v-show="item.show" :class="($route.path == item.link ? 'acitve' : '')">
            <template v-if="item.target == '_blank'"><a target="_blank" :href="item.link"><i :style="'background-image: url(' + item.icon  + ')'"></i><span v-text="item.name"></span></a></template>
            <template v-else><router-link :to="item.link"><i :style="'background-image: url(' + item.icon  + ')'"></i><span v-text="item.name"></span></router-link></template>
          </li>
        </ul>
      </div>
      <div id="bar_playlists">
        
        <h3>הפלייליסטים שלי</h3>

        <!--<span v-for="(n, index) in dropped" :key="index">Dropped {{n.name}};&nbsp;</span>-->
      
        <ul>
          <li v-for="item in playlists" :key="item.id">
            
          <drop class="droparea" @drop="onDrop(item, $event)">
            <router-link :to="'/playlist/' + item.id"><span v-text="item.name"></span></router-link>
          </drop>
        </li>
        </ul>
        <a class="add_playlist" @click="addPlaylistPopup"><div><i class="fas fa-plus"></i></div>הוסף פלייליסט חדש</a>
      </div>

  </div>
     
</template>

<script>
  
import { Drop } from "vue-easy-dnd";

export default {
  components: { Drop},
  props: ["user_data", "theme", "playlists"],
  data(){
    return {
      dropped: [],
      addPlaylistName: '',
      menu: [
        {name: 'ראשי', show:true, link: '/' , icon: require('@/assets/menu_inbox.svg')},
        {name: 'בשבילך', show:true, link: '/' + (this.get_me().is_pr ? 'pr_' : (this.get_me().type == 'media' ? 'media_' : '')) + 'dashboard', icon: require('@/assets/menu_personal.svg')},
        {name: 'אהבתי', show:true, link: '/likes', icon: require('@/assets/menu_personal.svg')},
        {name: 'לינקיפדיה', show:true, link: '/linkipedia' , icon: require('@/assets/menu_linkipedia.svg')},
        {name: 'המצעד', show:true, link: '/parade' , icon: require('@/assets/menu_mitzad.svg')},
        {name: 'הודעות', show:true, link: '/inboxIndex' , icon: require('@/assets/menu_inbox.svg')},
        {name: 'הגדרות', show:true, link: '/settings' , icon: require('@/assets/menu_settings.svg')},
        {name: 'הגדרות אמן', show:(this.get_me().type == 'artist'), link: '/settings_artist' , icon: require('@/assets/menu_settings.svg')},
        {name: 'ניהול הופעות', show:(this.get_me().type == 'artist'), link: '/edit_shows' , icon: require('@/assets/menu_settings.svg')},
        {name: 'תקליט', show:(this.get_me().type != 'media'), link: 'https://taklit.cc/', target: '_blank', icon: require('@/assets/menu_settings.svg')},
      ]
    }
  },
  methods: {
    addPlaylistPopup(){

			this.$swal.fire({
				title: 'הוספת פלייליסט חדש',
				input: 'text',
				inputAttributes: {
					autocapitalize: 'off'
				},
				showCancelButton: true,
				confirmButtonText: 'שמירה',
				showLoaderOnConfirm: true
			}).then((result) => { 

				if (result.isConfirmed) {
          this.api({ action: 'playlist/add', data: { name: result.value } }, (data) =>{ 
            this.$emit('addPlaylist', data.data, result.value);
            this.alert('הפלייליסט ' + result.value + ' נשמר');
          });

				}
			});

    },
      onDrop(playlist, e) {
        var self = this;
        // categories 
        this.api({ action: 'playlist/add_to', data: { playlist: playlist.id, item_id: e.data.id } }, function(){ 
          self.alert('השיר נוסף לפלייליסט')

        });

        this.dropped.push(e.data);
      },
    },
    computed:{
      show_bar(){
        if (this.$route.matched[0]?.name == 'item') return false;
        return true;
      }
    }
  
}
</script>

<style lang="scss" scoped>
#bar { position: fixed; width:200px; top: 0px; bottom: 0px; right: 0px; background: #1e212a; padding-top:20px; overflow-y: auto; text-align: center; z-index: 99999;}
.lnk_switch { margin-bottom: 25px;}
#bar_menu {  text-align:right; margin-bottom: 20px;
  li { display: block;  line-height: 60px;}
  li a { display: block;  padding: 0 15px; font-size: 20px;  color: #fff;}
  li a i { display: inline-block;  width:25px; height: 30px; background: right center no-repeat; vertical-align: middle; margin-left: 12px; }
  li:hover a, li.acitve a { background: #222f3c; color: #ff1661; }
}
.lnk_switch {
  & { border:1px solid #1e212a; padding: 3px; background: #fff; display: inline-block; border-radius: 25px; }
  a { height: 22px; border-radius: 20px; display: inline-block; padding: 0 8px;  color: #1e212a; }
  a.active { background: #1e212a; color: #fff;}
}
#bar_playlists {  padding: 0 15px; text-align: right;
  h3 { color: #fff; text-align: right;}
  ul { display: block; padding-bottom: 10px; margin-bottom: 10px; border-bottom: 1px dashed #fff;}
  li { display: block; height: 30px; line-height: 30px;}
  li span { font-size: 17px; display: block; color: #fff; opacity: 0.5; -moz-transition:all 0.1s ease 0s;-o-transition:all 0.1s ease 0s;-webkit-transition:all 0.1s ease 0s;transition:all 0.1s ease 0s; white-space: nowrap; overflow: hidden;}
  li span:before { content: "·"; margin-left: 8px;}
  
}

.droparea { 
  &{ width: 100%; height: auto;  }
  &:hover span { font-size: 24px; font-weight: bold; opacity: 1 !important; border:1px dashed #fff; border-radius: 6px; }
}

.add_playlist { color: #fff !important; font-size: 17px;
  div { width:20px; height: 20px; line-height: 20px; float: left; border-radius: 100%; border: 1px solid #fff; text-align: center; font-size: 8px; color: #fff; }
}

</style>